<template>
  <div style="">
    <div class="sub-nav-box-1">
      <!-- judul halaman -->
      <h2>
        Aktivitas
        <svg
          v-if="isManager()"
          @click="$router.push('/marketing/kategori-aktvitas')"
          style="margin-left: 18px; cursor: pointer"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.99997 11.1445C10.1834 11.1445 11.1428 10.1851 11.1428 9.00167C11.1428 7.81821 10.1834 6.85882 8.99997 6.85882C7.8165 6.85882 6.85711 7.81821 6.85711 9.00167C6.85711 10.1851 7.8165 11.1445 8.99997 11.1445Z"
            stroke="#4E4B66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.2857 11.1445C14.1906 11.36 14.1622 11.599 14.2042 11.8307C14.2463 12.0624 14.3567 12.2762 14.5214 12.4445L14.5643 12.4874C14.6971 12.6201 14.8024 12.7776 14.8743 12.951C14.9462 13.1245 14.9832 13.3104 14.9832 13.4981C14.9832 13.6858 14.9462 13.8717 14.8743 14.0452C14.8024 14.2186 14.6971 14.3761 14.5643 14.5088C14.4316 14.6416 14.274 14.747 14.1006 14.8189C13.9272 14.8908 13.7413 14.9278 13.5535 14.9278C13.3658 14.9278 13.1799 14.8908 13.0065 14.8189C12.8331 14.747 12.6755 14.6416 12.5428 14.5088L12.5 14.466C12.3316 14.3013 12.1178 14.1908 11.8861 14.1488C11.6544 14.1068 11.4154 14.1352 11.2 14.2302C10.9887 14.3208 10.8085 14.4711 10.6816 14.6628C10.5547 14.8544 10.4866 15.079 10.4857 15.3088V15.4302C10.4857 15.8091 10.3352 16.1725 10.0673 16.4404C9.79935 16.7083 9.43599 16.8588 9.05711 16.8588C8.67823 16.8588 8.31487 16.7083 8.04696 16.4404C7.77905 16.1725 7.62854 15.8091 7.62854 15.4302V15.366C7.62301 15.1295 7.54648 14.9002 7.4089 14.7079C7.27132 14.5155 7.07906 14.369 6.85711 14.2874C6.64167 14.1923 6.40268 14.1639 6.17097 14.206C5.93926 14.248 5.72545 14.3584 5.55711 14.5231L5.51425 14.566C5.38158 14.6988 5.22402 14.8042 5.05059 14.876C4.87717 14.9479 4.69127 14.9849 4.50354 14.9849C4.3158 14.9849 4.12991 14.9479 3.95648 14.876C3.78305 14.8042 3.6255 14.6988 3.49282 14.566C3.36 14.4333 3.25463 14.2757 3.18274 14.1023C3.11085 13.9289 3.07384 13.743 3.07384 13.5552C3.07384 13.3675 3.11085 13.1816 3.18274 13.0082C3.25463 12.8348 3.36 12.6772 3.49282 12.5445L3.53568 12.5017C3.70035 12.3333 3.81081 12.1195 3.85283 11.8878C3.89484 11.6561 3.86648 11.4171 3.77139 11.2017C3.68085 10.9904 3.5305 10.8102 3.33887 10.6833C3.14723 10.5564 2.92267 10.4883 2.69282 10.4874H2.57139C2.19251 10.4874 1.82915 10.3369 1.56124 10.069C1.29333 9.80106 1.14282 9.4377 1.14282 9.05882C1.14282 8.67994 1.29333 8.31657 1.56124 8.04867C1.82915 7.78076 2.19251 7.63025 2.57139 7.63025H2.63568C2.8721 7.62472 3.1014 7.54819 3.29375 7.41061C3.4861 7.27303 3.63262 7.08077 3.71425 6.85882C3.80933 6.64338 3.8377 6.40439 3.79568 6.17268C3.75367 5.94097 3.64321 5.72716 3.47854 5.55882L3.43568 5.51596C3.30286 5.38328 3.19749 5.22573 3.12559 5.0523C3.0537 4.87888 3.0167 4.69298 3.0167 4.50525C3.0167 4.31751 3.0537 4.13161 3.12559 3.95819C3.19749 3.78476 3.30286 3.62721 3.43568 3.49453C3.56836 3.36171 3.72591 3.25634 3.89934 3.18445C4.07276 3.11255 4.25866 3.07555 4.44639 3.07555C4.63413 3.07555 4.102403 3.11255 4.99345 3.18445C5.16688 3.25634 5.32443 3.36171 5.45711 3.49453L5.49997 3.53739C5.66831 3.70206 5.88212 3.81252 6.11383 3.85453C6.34554 3.89655 6.58453 3.86819 6.79997 3.7731H6.85711C7.06837 3.68256 7.24855 3.53221 7.37546 3.34058C7.50237 3.14894 7.57048 2.92438 7.57139 2.69453V2.5731C7.57139 2.19422 7.7219 1.83086 7.98981 1.56295C8.25772 1.29504 8.62109 1.14453 8.99997 1.14453C9.37885 1.14453 9.74221 1.29504 10.0101 1.56295C10.278 1.83086 10.4285 2.19422 10.4285 2.5731V2.63739C10.4295 2.86724 10.4976 3.0918 10.6245 3.28344C10.7514 3.47507 10.9316 3.62542 11.1428 3.71596C11.3583 3.81104 11.5972 3.83941 11.829 3.79739C12.0607 3.75538 12.2745 3.64491 12.4428 3.48025L12.4857 3.43739C12.6184 3.30457 12.7759 3.1992 12.9493 3.1273C13.1228 3.05541 13.3087 3.01841 13.4964 3.01841C13.6841 3.01841 13.87 3.05541 14.0435 3.1273C14.2169 3.1992 14.3744 3.30457 14.5071 3.43739C14.6399 3.57006 14.7453 3.72762 14.8172 3.90105C14.8891 4.07447 14.9261 4.26037 14.9261 4.4481C14.9261 4.63584 14.8891 4.82173 14.8172 4.99516C14.7453 5.16859 14.6399 5.32614 14.5071 5.45882L14.4643 5.50167C14.2996 5.67002 14.1891 5.88383 14.1471 6.11554C14.1051 6.34725 14.1335 6.58623 14.2285 6.80167V6.85882C14.3191 7.07008 14.4694 7.25026 14.6611 7.37717C14.8527 7.50408 15.0773 7.57219 15.3071 7.5731H15.4285C15.8074 7.5731 16.1708 7.72361 16.4387 7.99152C16.7066 8.25943 16.8571 8.62279 16.8571 9.00167C16.8571 9.38056 16.7066 9.74392 16.4387 10.0118C16.1708 10.2797 15.8074 10.4302 15.4285 10.4302H15.3643C15.1344 10.4312 14.9098 10.4993 14.7182 10.6262C14.5266 10.7531 14.3762 10.9333 14.2857 11.1445Z"
            stroke="#4E4B66"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </h2>
    </div>

    <!-- main view halaman -->
    <div style="margin-top: 70px; background: none" class="main-view">
      <div style="padding: 0px" class="sub-view">
        <div class="table-navigation">
          <!-- list filter -->
          <div class="list-filter">
            <!-- filter tanggal-->
            <div style="margin-right: 12px" class="filter-pilihan">
              <label for="date-picker" class="filter">
                <!-- tipe filter -->
                <p>Bulan :</p>
                <!-- value filter -->
                <span>{{
                  filterData.bulanStr ? filterData.bulanStr : "Semua"
                }}</span>
                <!-- icon filter -->
                <svg
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- input elemen -->
                <input
                  v-model="filterData.bulanStr"
                  id="date-picker"
                  class="date-control"
                  type="month"
                />
              </label>
            </div>
            <!-- end of filter tanggal -->

            <!-- filter Kategori-->
            <div class="filter-pilihan">
              <div @click="openClosePilihanFilterKategori(true)" class="filter">
                <!-- tipe filter -->
                <p>Kategori :</p>
                <!-- value filter -->
                <span>{{ filterData.kategori }}</span>
                <!-- icon filter -->
                <svg
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <!-- box pilihan filter -->
              <div
                style="margin-top: 2px; display: none"
                ref="boxPilihanFilterKategori"
                class="box-pilihan"
              >
                <p
                  @click="openClosePilihanFilterKategori(false, kategori.nama)"
                  :key="id"
                  v-for="(kategori, id) in mapKategoriAktivitasFilter"
                >
                  {{ kategori.nama }}
                  <svg
                    v-if="kategori === filterData.kategori"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <!-- end of box pilihan filter -->
            </div>
            <!-- end of filter kategori -->
          </div>
          <!-- end of list filter -->

          <!-- bagian untuk cari tambah dan download -->
          <div class="cari-tambah-download">
            <!-- box pencarian -->
            <div class="cari">
              <svg
                style="margin-right: 8px"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <input
                v-model="filterData.pencarian"
                placeholder="Cari"
                type="text"
                name=""
                id=""
              />
            </div>
            <!-- button tambah -->
            <button @click="openCloseModalInput(true)" class="add">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00003 5.14314V10.8574M5.14289 8.00028H10.8572M15.1429 8.00028C15.1429 11.9452 11.9449 15.1431 8.00003 15.1431C4.05514 15.1431 0.857178 11.9452 0.857178 8.00028C0.857178 4.05539 4.05514 0.857422 8.00003 0.857422C11.9449 0.857422 15.1429 4.05539 15.1429 8.00028Z"
                  stroke="#FCFCFC"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <!-- button download -->
            <button @click="downloadData" class="download">
              <svg
                width="16"
                height="16"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4286 9.14375V12.0009C13.4286 12.3798 13.278 12.7431 13.0101 13.011C12.7422 13.279 12.3789 13.4295 12 13.4295H1.99998C1.6211 13.4295 1.25774 13.279 0.98983 13.011C0.721921 12.7431 0.571411 12.3798 0.571411 12.0009V9.14375M3.42855 5.57227L6.99998 9.14369M6.99998 9.14369L10.5714 5.57227M6.99998 9.14369V0.572266"
                  stroke="#FCFCFC"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <!-- open menu mobile -->
            <div class="open-menu-mobile">
              <!-- menu icon -->
              <svg
                @click="openCloseMenuMobile(true)"
                width="14"
                height="4"
                viewBox="0 0 14 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <!-- end of menu icon -->

              <div
                style="display: none"
                ref="box-pilihan-menu"
                class="box-pilihan-aksi"
              >
                <!-- buka menu filter -->
                <p @click="openCloseFilterMobile(true)">
                  <svg
                    width="17"
                    height="15"
                    viewBox="0 0 17 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.2437 0.571289H1.04053L7.12179 7.32843V12.7141L10.1624 14.1427V7.32843L16.2437 0.571289Z"
                      stroke="#4E4B66"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Filter
                </p>
                <!-- tambah aktivitas -->
                <p @click="openCloseModalInput">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.00003 5.14265V10.8569M5.14289 7.99979H10.8572M15.1429 7.99979C15.1429 11.9447 11.9449 15.1426 8.00003 15.1426C4.05514 15.1426 0.857178 11.9447 0.857178 7.99979C0.857178 4.0549 4.05514 0.856934 8.00003 0.856934C11.9449 0.856934 15.1429 4.0549 15.1429 7.99979Z"
                      stroke="#FFB700"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Tambah
                </p>

                <!-- melakukan downlaod -->
                <p @click="downloadData">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.4287 9.14277V11.9999C13.4287 12.3788 13.2782 12.7422 13.0103 13.0101C12.7423 13.278 12.379 13.4285 12.0001 13.4285H2.0001C1.62122 13.4285 1.25786 13.278 0.989952 13.0101C0.722043 12.7422 0.571533 12.3788 0.571533 11.9999V9.14277M3.42868 5.57129L7.0001 9.14272M7.0001 9.14272L10.5715 5.57129M7.0001 9.14272V0.571289"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Download
                </p>
              </div>
            </div>
            <!-- end of open menu mobile -->
          </div>
        </div>
        <!-- end of bagian untuk cari tambah dan download -->

        <!-- filter mobile -->
        <div style="bottom: -100%" ref="filter-mobile" class="backdrop">
          <div class="filter-mobile">
            <div class="filter-mobile-title">
              <h5>
                Filter <br />
                Aktivitas
              </h5>
              <!-- close filter -->
              <svg
                @click="openCloseFilterMobile(false)"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
                  stroke="#1A1A1A"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <!-- input bulan -->
            <label tabindex="0" for="date-picker-lahir" class="box-form email">
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div style="position: relative" class="input-and-title">
                <span v-if="filterData.bulanStr" class="input-title">
                  Bulan
                </span>
                <input
                  style="width: 200px; height: 50px"
                  id="date-picker-lahir"
                  class="date-control"
                  type="month"
                  v-model="filterData.bulanStr"
                />
                <p>
                  {{ filterData.bulanStr ? filterData.bulanStr : "Bulan" }}
                </p>
              </div>
            </label>
            <!-- end of input bulan -->

            <!-- input kategori -->
            <div class="keterangan input-keterangan">
              <div
                @click="openClosePilihanFilterKategori(true)"
                ref="keterangan-form"
                class="box-form email"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div class="input-and-title">
                  <span
                    v-if="filterData.kategori"
                    style="display: block"
                    class="input-title"
                    >Kategori</span
                  >
                  <p>
                    {{ filterData.kategori ? filterData.kategori : "Kategori" }}
                  </p>
                </div>
              </div>
              <!-- box pilihan kategori -->
              <div
                style="display: none"
                ref="boxPilihanFilterKategoriMobile"
                class="box-pilihan"
              >
                <p
                  @click="openClosePilihanFilterKategori(false, kategori.nama)"
                  :key="id"
                  v-for="(kategori, id) in mapKategoriAktivitasFilter"
                >
                  {{ kategori.nama }}
                  <svg
                    v-if="kategori.nama === filterData.kategori"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <!-- end of box pilihan kategori -->
            </div>

            <!-- end of input kategori -->

            <div class="button-container">
              <button
                @click="openCloseFilterMobile(false)"
                class="yellow-button"
              >
                Terapkan
              </button>
            </div>
          </div>
        </div>
        <!-- end of filter mobile -->

        <!-- tabel -->
        <div class="box-table">
          <table>
            <!-- judul tabel  -->
            <tr>
              <th>Tanggal</th>
              <th>Kategori</th>
              <!-- <th style="width: 20%">Nama Target</th> -->
              <th>Nama Target</th>

              <th>Cabang</th>
              <th>Lampiran</th>
              <th>Status</th>
            </tr>
            <!-- start iterasi tabel -->
            <tr
              :key="index"
              v-for="(aktivitas, index) in listAktivitasFiltered"
            >
              <!-- Tanggal -->
              <td>
                <span style="color: #1d1d1d; font-weight: 700">{{
                  toDate(aktivitas.tanggalPengajuan.seconds)
                }}</span>
              </td>
              <!-- Kategori  -->
              <td>
                {{ aktivitas.kategori }}
              </td>
              <!-- Nama Target -->
              <td>
                <b>{{ aktivitas.namaTarget }}</b
                ><br />
                {{ aktivitas.email }}<br />
                {{ aktivitas.narahubung }}
              </td>
              <!-- Cabang -->
              <td>
                {{ userData.penempatan }}<br />
                <div v-if="isManager()">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5714 11.1431V10.0003C10.5714 9.39407 10.3306 8.81269 9.90197 8.38404C9.47332 7.95538 8.89194 7.71457 8.28573 7.71457H3.7143C3.10809 7.71457 2.52671 7.95538 2.09806 8.38404C1.6694 8.81269 1.42859 9.39407 1.42859 10.0003V11.1431M8.28573 3.14314C8.28573 4.4055 7.26238 5.42885 6.00002 5.42885C4.73765 5.42885 3.7143 4.4055 3.7143 3.14314C3.7143 1.88077 4.73765 0.857422 6.00002 0.857422C7.26238 0.857422 8.28573 1.88077 8.28573 3.14314Z"
                      stroke="#4E4B66"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{ aktivitas.reviewer }}
                </div>
              </td>
              <!-- Lampiran  -->
              <td class="tabel-lampiran">
                <p
                  @click="openCloseModalViewer(true, aktivitas.lampiranUrl[0])"
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.42862 0.857422H2.71434C2.33546 0.857422 1.97209 1.00793 1.70419 1.27584C1.43628 1.54375 1.28577 1.90711 1.28577 2.28599V13.7146C1.28577 14.0934 1.43628 14.4568 1.70419 14.7247C1.97209 14.9926 2.33546 15.1431 2.71434 15.1431H11.2858C11.6646 15.1431 12.028 14.9926 12.2959 14.7247C12.5638 14.4568 12.7143 14.0934 12.7143 13.7146V5.14314M8.42862 0.857422L12.7143 5.14314M8.42862 0.857422V5.14314H12.7143M9.85719 8.71456H4.14291M9.85719 11.5717H4.14291M5.57148 5.85742H4.14291"
                      stroke="#A0A3BD"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span>Dokumen</span>
                </p>
              </td>

              <!-- Status action -->
              <td>
                <div @click="openCloseAction(true, index)">
                  <div
                    v-if="aktivitas.status === 'pending'"
                    class="status-rounded-pending"
                  >
                    Diproses
                  </div>
                  <div
                    v-else-if="aktivitas.status === 'accepted'"
                    class="status-rounded-accepted"
                  >
                    Diterima
                  </div>
                  <div
                    v-else-if="aktivitas.status === 'rejected'"
                    class="status-rounded-rejected"
                  >
                    Ditolak
                  </div>
                </div>
                <div
                  style="display: none"
                  ref="boxPilihanAksi"
                  class="box-pilihan-aksi"
                >
                  <p @click="openCloseAction(false, index, 'accepted')">
                    <svg
                      width="14"
                      height="10"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7236 0.714844L4.36182 8.57199L0.561035 5.00056"
                        stroke="#00BA88"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Terima
                  </p>
                  <p @click="openCloseAction(false, index, 'rejected')">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.28578 0.714844L0.714355 9.28627M0.714355 0.714844L9.28578 9.28627"
                        stroke="#EB5757"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Tolak
                  </p>
                </div>
              </td>
            </tr>

            <!-- end iterasi tabel -->
          </table>
          <p
            v-if="!listAktivitasFiltered || listAktivitasFiltered.length === 0"
            class="empty-state-table"
          >
            Belum ada data
          </p>
        </div>
        <!-- end of tabel -->

        <!-- modal tambah aktivitas -->
        <ModalInput v-if="modalInputIsOpen">
          <div style="max-width: 730px" class="content">
            <h2>Pengajuan Aktivitas</h2>
            <!-- input form -->
            <div class="list-form-modal">
              <!-- Kategori -->
              <div class="keterangan">
                <div
                  ref="kategori-form"
                  @click="openClosePilihanKategori(true)"
                  class="box-form email"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.857178 11.5717L8.00003 15.1431L15.1429 11.5717M0.857178 8.00028L8.00003 11.5717L15.1429 8.00028M8.00003 0.857422L0.857178 4.42885L8.00003 8.00028L15.1429 4.42885L8.00003 0.857422Z"
                      stroke="#A0A3BD"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div class="input-and-title">
                    <span
                      v-if="tambahAktivitas.kategori"
                      style="display: block"
                      class="input-title"
                      >Kategori</span
                    >

                    <p>
                      {{
                        tambahAktivitas.kategori
                          ? tambahAktivitas.kategori
                          : "Kategori"
                      }}
                    </p>
                  </div>
                </div>
                <!-- box pilihan Kategori -->
                <div
                  style="display: none"
                  ref="boxPilihanKategori"
                  class="box-pilihan"
                >
                  <p
                    :key="id"
                    v-for="(kategori, id) in mapKategoriAktivitas"
                    @click="openClosePilihanKategori(false, kategori.nama)"
                  >
                    {{ kategori.nama }}
                    <svg
                      v-if="tambahAktivitas.kategori === kategori"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                        stroke="#00BA88"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </p>
                </div>
                <!-- end of box pilihan Kategori-->
              </div>
              <!-- end of Kategori -->

              <!-- Nama Target -->
              <div ref="nama-target-form" class="box-form email">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask id="path-1-inside-1" fill="white">
                    <path
                      d="M8.00003 15.1431C11.9449 15.1431 15.1429 11.9452 15.1429 8.00028C15.1429 4.05539 11.9449 0.857422 8.00003 0.857422C4.05514 0.857422 0.857178 4.05539 0.857178 8.00028C0.857178 11.9452 4.05514 15.1431 8.00003 15.1431Z"
                    />
                    <path
                      d="M8.71432 5.14314C8.71432 5.53762 8.39452 5.85742 8.00003 5.85742C7.60555 5.85742 7.28575 5.53762 7.28575 5.14314C7.28575 4.74865 7.60555 4.42885 8.00003 4.42885C8.39452 4.42885 8.71432 4.74865 8.71432 5.14314Z"
                    />
                  </mask>
                  <path
                    d="M7.50003 10.8574C7.50003 11.1336 7.72389 11.3574 8.00003 11.3574C8.27618 11.3574 8.50003 11.1336 8.50003 10.8574H7.50003ZM8.50003 8.00028C8.50003 7.72414 8.27618 7.50028 8.00003 7.50028C7.72389 7.50028 7.50003 7.72414 7.50003 8.00028H8.50003ZM8.50003 10.8574V8.00028H7.50003V10.8574H8.50003ZM14.1429 8.00028C14.1429 11.3929 11.3926 14.1431 8.00003 14.1431V16.1431C12.4972 16.1431 16.1429 12.4975 16.1429 8.00028H14.1429ZM8.00003 14.1431C4.60743 14.1431 1.85718 11.3929 1.85718 8.00028H-0.142822C-0.142822 12.4975 3.50286 16.1431 8.00003 16.1431V14.1431ZM1.85718 8.00028C1.85718 4.60767 4.60743 1.85742 8.00003 1.85742V-0.142578C3.50286 -0.142578 -0.142822 3.5031 -0.142822 8.00028H1.85718ZM8.00003 1.85742C11.3926 1.85742 14.1429 4.60767 14.1429 8.00028H16.1429C16.1429 3.5031 12.4972 -0.142578 8.00003 -0.142578V1.85742ZM7.71432 5.14314C7.71432 4.98534 7.84224 4.85742 8.00003 4.85742V6.85742C8.94681 6.85742 9.71432 6.08991 9.71432 5.14314H7.71432ZM8.00003 4.85742C8.15783 4.85742 8.28575 4.98534 8.28575 5.14314H6.28575C6.28575 6.08991 7.05326 6.85742 8.00003 6.85742V4.85742ZM8.28575 5.14314C8.28575 5.30093 8.15783 5.42885 8.00003 5.42885V3.42885C7.05326 3.42885 6.28575 4.19636 6.28575 5.14314H8.28575ZM8.00003 5.42885C7.84224 5.42885 7.71432 5.30093 7.71432 5.14314H9.71432C9.71432 4.19636 8.94681 3.42885 8.00003 3.42885V5.42885Z"
                    fill="#A0A3BD"
                    mask="url(#path-1-inside-1)"
                  />
                </svg>

                <div class="input-and-title">
                  <span v-if="tambahAktivitas.namaTarget" class="input-title"
                    >Nama Target</span
                  >
                  <input
                    v-model="tambahAktivitas.namaTarget"
                    class="input-text"
                    required
                    placeholder="Nama Target"
                    type="text"
                  />
                </div>
              </div>
              <!-- end of Nama Target -->

              <!-- Narahubung -->
              <div ref="narahubung-form" class="box-form email">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask id="path-1-inside-1" fill="white">
                    <path
                      d="M8.00003 15.1431C11.9449 15.1431 15.1429 11.9452 15.1429 8.00028C15.1429 4.05539 11.9449 0.857422 8.00003 0.857422C4.05514 0.857422 0.857178 4.05539 0.857178 8.00028C0.857178 11.9452 4.05514 15.1431 8.00003 15.1431Z"
                    />
                    <path
                      d="M8.71432 5.14314C8.71432 5.53762 8.39452 5.85742 8.00003 5.85742C7.60555 5.85742 7.28575 5.53762 7.28575 5.14314C7.28575 4.74865 7.60555 4.42885 8.00003 4.42885C8.39452 4.42885 8.71432 4.74865 8.71432 5.14314Z"
                    />
                  </mask>
                  <path
                    d="M7.50003 10.8574C7.50003 11.1336 7.72389 11.3574 8.00003 11.3574C8.27618 11.3574 8.50003 11.1336 8.50003 10.8574H7.50003ZM8.50003 8.00028C8.50003 7.72414 8.27618 7.50028 8.00003 7.50028C7.72389 7.50028 7.50003 7.72414 7.50003 8.00028H8.50003ZM8.50003 10.8574V8.00028H7.50003V10.8574H8.50003ZM14.1429 8.00028C14.1429 11.3929 11.3926 14.1431 8.00003 14.1431V16.1431C12.4972 16.1431 16.1429 12.4975 16.1429 8.00028H14.1429ZM8.00003 14.1431C4.60743 14.1431 1.85718 11.3929 1.85718 8.00028H-0.142822C-0.142822 12.4975 3.50286 16.1431 8.00003 16.1431V14.1431ZM1.85718 8.00028C1.85718 4.60767 4.60743 1.85742 8.00003 1.85742V-0.142578C3.50286 -0.142578 -0.142822 3.5031 -0.142822 8.00028H1.85718ZM8.00003 1.85742C11.3926 1.85742 14.1429 4.60767 14.1429 8.00028H16.1429C16.1429 3.5031 12.4972 -0.142578 8.00003 -0.142578V1.85742ZM7.71432 5.14314C7.71432 4.98534 7.84224 4.85742 8.00003 4.85742V6.85742C8.94681 6.85742 9.71432 6.08991 9.71432 5.14314H7.71432ZM8.00003 4.85742C8.15783 4.85742 8.28575 4.98534 8.28575 5.14314H6.28575C6.28575 6.08991 7.05326 6.85742 8.00003 6.85742V4.85742ZM8.28575 5.14314C8.28575 5.30093 8.15783 5.42885 8.00003 5.42885V3.42885C7.05326 3.42885 6.28575 4.19636 6.28575 5.14314H8.28575ZM8.00003 5.42885C7.84224 5.42885 7.71432 5.30093 7.71432 5.14314H9.71432C9.71432 4.19636 8.94681 3.42885 8.00003 3.42885V5.42885Z"
                    fill="#A0A3BD"
                    mask="url(#path-1-inside-1)"
                  />
                </svg>

                <div class="input-and-title">
                  <span v-if="tambahAktivitas.narahubung" class="input-title"
                    >Narahubung</span
                  >
                  <input
                    v-model="tambahAktivitas.narahubung"
                    class="input-text"
                    required
                    placeholder="Narahubung - No telepon"
                    type="text"
                  />
                </div>
              </div>
              <!-- end of Narahubung -->

              <!-- Email -->
              <div ref="email-form" class="box-form email">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask id="path-1-inside-1" fill="white">
                    <path
                      d="M8.00003 15.1431C11.9449 15.1431 15.1429 11.9452 15.1429 8.00028C15.1429 4.05539 11.9449 0.857422 8.00003 0.857422C4.05514 0.857422 0.857178 4.05539 0.857178 8.00028C0.857178 11.9452 4.05514 15.1431 8.00003 15.1431Z"
                    />
                    <path
                      d="M8.71432 5.14314C8.71432 5.53762 8.39452 5.85742 8.00003 5.85742C7.60555 5.85742 7.28575 5.53762 7.28575 5.14314C7.28575 4.74865 7.60555 4.42885 8.00003 4.42885C8.39452 4.42885 8.71432 4.74865 8.71432 5.14314Z"
                    />
                  </mask>
                  <path
                    d="M7.50003 10.8574C7.50003 11.1336 7.72389 11.3574 8.00003 11.3574C8.27618 11.3574 8.50003 11.1336 8.50003 10.8574H7.50003ZM8.50003 8.00028C8.50003 7.72414 8.27618 7.50028 8.00003 7.50028C7.72389 7.50028 7.50003 7.72414 7.50003 8.00028H8.50003ZM8.50003 10.8574V8.00028H7.50003V10.8574H8.50003ZM14.1429 8.00028C14.1429 11.3929 11.3926 14.1431 8.00003 14.1431V16.1431C12.4972 16.1431 16.1429 12.4975 16.1429 8.00028H14.1429ZM8.00003 14.1431C4.60743 14.1431 1.85718 11.3929 1.85718 8.00028H-0.142822C-0.142822 12.4975 3.50286 16.1431 8.00003 16.1431V14.1431ZM1.85718 8.00028C1.85718 4.60767 4.60743 1.85742 8.00003 1.85742V-0.142578C3.50286 -0.142578 -0.142822 3.5031 -0.142822 8.00028H1.85718ZM8.00003 1.85742C11.3926 1.85742 14.1429 4.60767 14.1429 8.00028H16.1429C16.1429 3.5031 12.4972 -0.142578 8.00003 -0.142578V1.85742ZM7.71432 5.14314C7.71432 4.98534 7.84224 4.85742 8.00003 4.85742V6.85742C8.94681 6.85742 9.71432 6.08991 9.71432 5.14314H7.71432ZM8.00003 4.85742C8.15783 4.85742 8.28575 4.98534 8.28575 5.14314H6.28575C6.28575 6.08991 7.05326 6.85742 8.00003 6.85742V4.85742ZM8.28575 5.14314C8.28575 5.30093 8.15783 5.42885 8.00003 5.42885V3.42885C7.05326 3.42885 6.28575 4.19636 6.28575 5.14314H8.28575ZM8.00003 5.42885C7.84224 5.42885 7.71432 5.30093 7.71432 5.14314H9.71432C9.71432 4.19636 8.94681 3.42885 8.00003 3.42885V5.42885Z"
                    fill="#A0A3BD"
                    mask="url(#path-1-inside-1)"
                  />
                </svg>

                <div class="input-and-title">
                  <span v-if="tambahAktivitas.email" class="input-title"
                    >Email</span
                  >
                  <input
                    v-model="tambahAktivitas.email"
                    class="input-text"
                    required
                    placeholder="Email"
                    type="text"
                  />
                </div>
              </div>
              <!-- end of Email -->

              <!-- lampiran dokumen -->
              <div class="input-lampiran">
                <label ref="lampiran-form" class="box-form email">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.4284 9.14369V12.0008C13.4284 12.3797 13.2779 12.7431 13.01 13.011C12.7421 13.2789 12.3787 13.4294 11.9999 13.4294H1.99986C1.62098 13.4294 1.25762 13.2789 0.989708 13.011C0.721799 12.7431 0.571289 12.3797 0.571289 12.0008V9.14369M10.5713 4.14369L6.99986 0.572266M6.99986 0.572266L3.42843 4.14369M6.99986 0.572266V9.14369"
                      stroke="#A0A3BD"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <div class="input-and-title">
                    <span style="display: none" class="input-title"
                      >Lampiran</span
                    >
                    <input
                      ref="lampiran-input"
                      @change="processFile($event)"
                      class="input-text"
                      type="file"
                      accept="image/*,.pdf"
                    />
                    <p>
                      {{
                        tambahAktivitas.lampiran
                          ? tambahAktivitas.lampiran.name
                          : "Lampiran.pdf"
                      }}
                    </p>
                  </div>
                </label>
                <!-- keterangan file -->
                <p style="margin-top: -29px; color: #a0a3bd">
                  Format .pdf, .jpg, .jpeg, .png (max: 3.5 MB) (max: 3.5 MB)
                </p>
              </div>
              <!-- end of lampiran dokumen -->
            </div>
            <!-- end of input form -->
            <hr />
            <button
              :disabled="isProcessing"
              @click="tambahkanAktivitas"
              style="margin: 20px"
              class="yellow-button"
            >
              <div ref="spinner" style="display: none" class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
              <span ref="button-text">Tambah Data</span>
            </button>
          </div>

          <!-- close button -->
          <svg
            @click="openCloseModalInput(false)"
            class="close-button"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
              stroke="#1D1D1D"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of close button -->
        </ModalInput>
        <!-- end of modal -->

        <!-- modal berhasil -->
        <ModalBerhasil v-if="modalBerhasilIsOpen">
          <!-- icon modal -->
          <template v-slot:icon>
            <svg
              width="89"
              height="88"
              viewBox="0 0 89 88"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
              <path
                d="M65.4526 42.0845V44.0121C65.45 48.5303 63.987 52.9267 61.2817 56.5454C58.5764 60.1642 54.7738 62.8116 50.441 64.0927C46.1082 65.3737 41.4773 65.2199 37.2391 63.6541C33.0009 62.0883 29.3824 59.1944 26.9232 55.4041C24.464 51.6137 23.296 47.13 23.5933 42.6215C23.8906 38.1131 25.6372 33.8215 28.5728 30.3869C31.5084 26.9523 35.4756 24.5586 39.8827 23.5629C44.2899 22.5672 48.9008 23.0227 53.0279 24.8616M65.4526 27.2502L44.5002 48.2236L38.2145 41.9378"
                stroke="#FCFCFC"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </template>
          <!-- text modal -->
          <template v-slot:text>
            <h2>Sukses Tambah Data</h2>
          </template>
          <!-- close button -->
          <template v-slot:close>
            <svg
              @click="openCloseModalBerhasil(false)"
              class="close-button"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
                stroke="#1D1D1D"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </template>
        </ModalBerhasil>
        <!-- end of modal berhasil -->

        <!-- modal view lampiran -->
        <ModalViewer v-if="modalViewerIsOpen">
          <div style="text-align: center" class="modal-content">
            <object
              style="object-fit: cover; margin: 10px 0px"
              :data="urlLampiran"
              width="750"
              height="390"
            ></object>

            <button
              @click="openDokumen"
              style="margin-top: 10px"
              class="yellow-button"
            >
              Buka dokumen
            </button>
          </div>
          <!-- close button -->
          <svg
            @click="openCloseModalViewer(false)"
            style="margin-top: -438px; margin-left: 340px"
            class="close-button"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
              stroke="#1D1D1D"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of close button -->
        </ModalViewer>
        <!-- end of modal view lampiran -->
      </div>
      <!-- end of main view halaman -->
    </div>
  </div>
</template>

<script>
import ModalInput from "@/components/modal/ModalInput";
import ModalBerhasil from "@/components/modal/ModalAlert";
import ModalViewer from "@/components/modal/RelativeModal";
import XLSX from "xlsx";
import { mapState } from "vuex";
import * as soluhafire from "@/soluhafire";
import * as soluhaApi from "@/soluhaApi";

export default {
  components: {
    ModalInput,
    ModalBerhasil,
    ModalViewer,
  },

  data() {
    return {
      isProcessing: false,
      // status modal
      modalInputIsOpen: false,
      modalBerhasilIsOpen: false,
      modalViewerIsOpen: false,
      // filter
      filterData: {
        bulanStr: "",
        bulan: null,
        kategori: "Semua",
        pencarian: "",
      },
      tambahAktivitas: {
        kategori: "",
        namaTarget: "",
        narahubung: "",
        email: "",
        lampiran: null,
      },
      // data modal view
      urlLampiran: "",
    };
  },

  methods: {
    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseFilterMobile(isOpen) {
      this.openCloseMenuMobile(false);
      let box = this.$refs["filter-mobile"];
      if (isOpen) box.style.bottom = "0px";
      else box.style.bottom = "-100%";
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    processFile(event) {
      this.tambahAktivitas.lampiran = event.target.files[0];
      let title = event.target.previousSibling;
      if (event.target.value.length > 0) title.style.display = "block";
      else title.style.display = "none";
    },

    checkForm() {
      let valid = true;

      if (this.tambahAktivitas.kategori === "") {
        this.$refs["kategori-form"].classList.add("failed-box-form");
        valid = false;
      }
      if (this.tambahAktivitas.namaTarget === "") {
        this.$refs["nama-target-form"].classList.add("failed-box-form");
        valid = false;
      }
      if (this.tambahAktivitas.narahubung === "") {
        this.$refs["narahubung-form"].classList.add("failed-box-form");
        valid = false;
      }
      if (!this.validateEmail(this.tambahAktivitas.email)) {
        this.$refs["email-form"].classList.add("failed-box-form");
        valid = false;
      }
      if (this.tambahAktivitas.lampiran === null) {
        this.$refs["lampiran-form"].classList.add("failed-box-form");
        valid = false;
      }
      if (this.$refs["lampiran-input"].files[0].size >= 3500000) {
        this.$refs["lampiran-form"].classList.add("failed-box-form");
        valid = false;
      }
      return valid;
    },

    async tambahkanAktivitas() {
      // cek apakah ada field yang kosong
      if (this.checkForm()) {
        this.loader(true);
        await soluhafire.tambahAktivitas(
          this.tambahAktivitas.kategori,
          this.tambahAktivitas.namaTarget,
          this.tambahAktivitas.narahubung,
          this.tambahAktivitas.email,
          this.tambahAktivitas.lampiran,
          this.userData.penempatan,
          this.userData.nama,
          this.userDocId
        );
        this.loader(false);
        this.clearInput();
        this.openCloseModalBerhasil(true);
      }
    },

    // validate email
    validateEmail(email) {
      let re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

    clearInput() {
      this.tambahAktivitas.kategori = "";
      this.tambahAktivitas.namaTarget = "";
      this.tambahAktivitas.narahubung = "";
      this.tambahAktivitas.email = "";
      this.tambahAktivitas.lampiran = null;
    },

    downloadData() {
      this.openCloseMenuMobile(false);
      let dataAktivitas = [];
      this.listAktivitasFiltered.forEach((aktivitas) => {
        dataAktivitas.push({
          tanggalPengajuan: this.toDate(
            parseInt(aktivitas.tanggalPengajuan.seconds)
          ),
          kategori: aktivitas.kategori,
          namaTarget: `${aktivitas.namaTarget} - ${aktivitas.email} - ${aktivitas.narahubung}`,
          cabang: this.userData.penempatan,
          status: aktivitas.status,
        });
      });
      const data = XLSX.utils.json_to_sheet(dataAktivitas);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `data_aktivitas_${soluhafire.getDate()}.xlsx`); // TODO: use local time instead
    },

    openDokumen() {
      window.open(this.urlLampiran, "_blank");
    },

    loader(isLoading) {
      let textButton = this.$refs["button-text"];
      let spinner = this.$refs["spinner"];

      if (isLoading) {
        textButton.style.display = "none";
        spinner.style.display = "block";
        this.isProcessing = true;
      } else {
        textButton.style.display = "block";
        spinner.style.display = "none";
        this.isProcessing = false;
      }
    },

    // Start of modal open close logic
    openClosePilihanFilterKategori(isOpen, value) {
      let box = this.$refs.boxPilihanFilterKategori;
      let boxMobile = this.$refs.boxPilihanFilterKategoriMobile;
      if (isOpen) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        box.style.display = "none";
        boxMobile.style.display = "none";
        this.filterData.kategori = value;
      }
    },

    openClosePilihanKategori(isOpen, value) {
      let box = this.$refs.boxPilihanKategori;
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.tambahAktivitas.kategori = value;
      }
    },

    // modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalInputIsOpen = false;
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    // View Lampiran
    openCloseModalViewer(isOpen, url) {
      if (isOpen) {
        this.urlLampiran = url;
        this.modalViewerIsOpen = true;
      } else {
        this.urlLampiran = "";
        this.modalViewerIsOpen = false;
      }
    },

    openCloseModalInput(isOpen) {
      if (isOpen) {
        this.openCloseMenuMobile(false);
        this.modalInputIsOpen = true;
      } else {
        this.modalInputIsOpen = false;
      }
    },

    openCloseAction(isOpen, index, newStatus = null) {
      let box = this.$refs.boxPilihanAksi[index];
      // tutup box action yang lain
      this.$refs["boxPilihanAksi"].forEach((refs) => {
        refs.style.display = "none";
      });
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        let curAktivitas = this.listAktivitasFiltered[index];
        soluhafire.ubahStatusAktivitas(
          curAktivitas.docId,
          this.userDocId,
          newStatus
        );
      }
    },
    // end of open close modal logic

    monthStringToDateRange(inStr) {
      let [year, month] = inStr.split("-");
      // month minus 1 cause js month is 0 indexing (0 is january)
      let dateAwal = new Date(parseInt(year), parseInt(month) - 1);

      let dateAkhir = new Date(dateAwal);
      this.addMonths(dateAkhir, 1);
      return {
        awal: dateAwal,
        akhir: dateAkhir,
      };
    },

    addMonths(date, months) {
      let d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() != d) {
        date.setDate(0);
      }
      return date;
    },

    isManager() {
      return this.userData.jabatan === "manager";
    },
  },

  watch: {
    "filterData.bulanStr": {
      handler: function (newVal) {
        if (newVal && newVal.length > 0) {
          this.filterData.bulan = this.monthStringToDateRange(newVal);
        } else {
          this.filterData.bulan = null;
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapState([
      "userData",
      "userDocId",
      "listAktivitas",
      "mapKategoriAktivitas",
    ]),

    listAktivitasFiltered() {
      let listAktivitas = this.listAktivitas;
      let filterBulan = this.filterData.bulan;

      let filterKategori = this.filterData.kategori;
      if (filterKategori === "Semua") filterKategori = "";

      let filterPencarian = this.filterData.pencarian.toLowerCase();
      if (listAktivitas) {
        return listAktivitas.filter(function (aktivitas) {
          let passFlag = true;
          // Filter aktivitas bedasarkan waktu
          if (filterBulan) {
            passFlag =
              aktivitas.tanggalPengajuan.seconds >=
                filterBulan.awal.getTime() / 1000 &&
              aktivitas.tanggalPengajuan.seconds <
                filterBulan.akhir.getTime() / 1000;
          }
          if (!passFlag) return false;

          // Filter aktivitas bedasarkan kategori
          if (filterKategori && filterKategori.length > 0) {
            passFlag = aktivitas.kategori === filterKategori;
          }
          if (!passFlag) return false;

          // Filter aktivitas bedasarkan keyword
          // passFlag = namaTargetFlag || emailFlag || narahubungFlag
          if (filterPencarian && filterPencarian.length > 0) {
            passFlag = aktivitas.namaTarget
              .toLowerCase()
              .includes(filterPencarian);

            if (!passFlag) {
              passFlag = aktivitas.email
                .toLowerCase()
                .includes(filterPencarian);
            }

            if (!passFlag) {
              passFlag = aktivitas.narahubung
                .toLowerCase()
                .includes(filterPencarian);
            }
          }
          return passFlag;
        });
      }
      return [];
    },

    mapKategoriAktivitasFilter() {
      // tambah "Semua" dari list kategori yang bisa dipilih
      let mapKategoriAktivitasFilter = { ...this.mapKategoriAktivitas };
      mapKategoriAktivitasFilter["Semua"] = { nama: "Semua" };
      return mapKategoriAktivitasFilter;
    },
  },
};
</script>

<style scoped>
.failed-box-form {
  border-color: #eb5757;
}

.failed-box-form * {
  color: #eb5757;
  stroke: #eb5757;
}
</style>
